import {
    GET_USERS,
    GET_QR_LIST,
    GET_BUILD_DATA,
    SET_ENV_BUILD,
    GET_JOB_PACKS,
    GET_DEPARTMENTS, GET_AREAS,
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { push } from "connected-react-router";

export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot =>
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            })
                        );
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const getQr = () => {
    return dispatch => {
        dispatch({ type: GET_QR_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_QR_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/equipment")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QR_LIST.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_QR_LIST.FAIL });
        }
    };
};

export const getBuildData = () => {
    return dispatch => {
        dispatch({ type: GET_BUILD_DATA.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/app_information`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_BUILD_DATA.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_BUILD_DATA.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_BUILD_DATA.FAIL });
        }
    };
};
export const setEnvBuild = build => {
    return dispatch => {
        dispatch({ type: SET_ENV_BUILD, payload: build });
    };
};
export const getJobPacks = () => {
    return dispatch => {
        dispatch({ type: GET_JOB_PACKS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/active`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_JOB_PACKS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_JOB_PACKS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_JOB_PACKS.FAIL });
        }
    };
};
export const redirectTo = link => {
    return dispatch => {
        dispatch(push(link));
    };
};
export const getDepartments = () => {
    return dispatch => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};